import { create } from 'zustand';

export interface Budget {
  id: string;
  familyId: string;
  walletId: string;
  categoryId: string;
  amount: number;
  period: 'monthly' | 'weekly' | 'yearly';
  alertAt: number;
}

interface BudgetsStore {
  budgets: Budget[];
  setBudgets: (b: Budget[]) => void;
  addBudget: (b: Budget) => void;
  updateBudget: (id: string, patch: Partial<Budget>) => void;
  removeBudget: (id: string) => void;
  reset: () => void;
}

export const useBudgetsStore = create<BudgetsStore>((set) => ({
  budgets: [],
  setBudgets: (budgets) => set({ budgets }),
  addBudget: (b) => set((s) => ({ budgets: [b, ...s.budgets] })),
  updateBudget: (id, patch) =>
    set((s) => ({ budgets: s.budgets.map((b) => (b.id === id ? { ...b, ...patch } : b)) })),
  removeBudget: (id) => set((s) => ({ budgets: s.budgets.filter((b) => b.id !== id) })),
  reset: () => set({ budgets: [] }),
}));
